// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { UIModelBaseElement } from './UIModelBaseElement';
import { UIModelComponent } from './UIModelComponent';
import { UIPage } from './UIPage';
import { UIView } from './UIView';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 页面视图 实体类
 * 定义页面和视图的关系
 */
export class PageView extends UIModelBaseElement {
  /** 是否可移除 : 是否可移除，不可移除的视图不提供删除功能，要求移除后对页面功能没有影响 */
  private _isRemovable: boolean;

  /** 设置：是否可移除 */
  public get isRemovable() {
    return this._isRemovable;
  }

  /** 获取：是否可移除 */
  public set isRemovable(value: boolean) {
    this._isRemovable = value;
  }

  /** 已移除 : 已移除的视图用户不可见 */
  private _removed: boolean;

  /** 设置：已移除 */
  public get removed() {
    return this._removed;
  }

  /** 获取：已移除 */
  public set removed(value: boolean) {
    this._removed = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: UIModelComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: UIModelComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 页面 的ID */
  private _page_ID: string;

  /** 获取：页面 的ID */
  public get page_ID() {
    return this._page_ID;
  }

  /** 设置：页面 的ID */
  public set page_ID(value: string) {
    this._page_ID = value;
  }

  /** 页面  */
  private _page: UIPage;

  /** 获取：页面  */
  public get page() {
    return this._page;
  }

  /** 设置：页面  */
  public set page(value: UIPage) {
    this._page = value;
    if (value !== null) {
      this.page_ID = value.id;
    } else {
      this.page_ID = '';
    }
  }

  /** 视图 的ID */
  private _view_ID: string;

  /** 获取：视图 的ID */
  public get view_ID() {
    return this._view_ID;
  }

  /** 设置：视图 的ID */
  public set view_ID(value: string) {
    this._view_ID = value;
  }

  /** 视图  */
  private _view: UIView;

  /** 获取：视图  */
  public get view() {
    return this._view;
  }

  /** 设置：视图  */
  public set view(value: UIView) {
    this._view = value;
    if (value !== null) {
      this.view_ID = value.id;
    } else {
      this.view_ID = '';
    }
  }

  constructor() {
    super();
    this._isRemovable = false;
    this._removed = false;
    this._component_ID = '';
    this._component = null;
    this._page_ID = '';
    this._page = null;
    this._view_ID = '';
    this._view = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PageView, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isRemovable = element.isRemovable;
      this.removed = element.removed;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.page_ID = element.page_ID;
      if (hasReference && element.page !== null) {
        this.page = element.page;
      }
      this.view_ID = element.view_ID;
      if (hasReference && element.view !== null) {
        this.view = element.view;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isRemovable = json.IsRemovable;
    this.removed = json.Removed;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = UIModelComponent.Create(json.Component);
    // }
    this.page_ID = json.Page_ID;
    // if (json.Page !== null) {
    //   this.page = UIPage.Create(json.Page);
    // }
    this.view_ID = json.View_ID;
    // if (json.View !== null) {
    //   this.view = UIView.Create(json.View);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsRemovable = this.isRemovable;
    json.Removed = this.removed;
    json.Component_ID = this.component_ID;
    json.Page_ID = this.page_ID;
    json.View_ID = this.view_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): PageView {
    const pageView = new PageView();
    pageView.Deserialize(json);
    pageView.json = json;
    return pageView;
  }
}
